import {createSelector} from 'reselect'
import type {RootState} from 'services/store'

export const rootWalletSelector = (state: RootState) => state.wallet
export const walletSelector = createSelector([rootWalletSelector], wallet => wallet.data)
